enum AnalyticsLocation {
  CONSTITUENT = 'constituent',
  GAB = 'gab',
  HOMEPAGE = 'homepage',
  TASKS = 'tasks',
}

export default AnalyticsLocation;
